export const FRAMEWORKS = [
  'react',
  'react-rsuite5',
  'react-material-ui',
  'react-bootstrap',
  'react-antd',
  'react-mantine'
];

export const FRAMEWORKS_LABELS = [
  'React',
  'React + RSuite5',
  'React + MaterialUI',
  'React + Bootstrap',
  'React + Ant Design',
  'React + Mantine'
];

export const FIELDS_KEY = ['fields', 'leftFields', 'rightField', 'centerFields'];
